module.exports = __webpack_public_path__ + "static/media/stronghold.fda813b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stronghold.png
// module id = 2459
// module chunks = 0